<template>
  <div class="frontCommon">
    <commonBanner :bgImg="bgImg" :search="false"></commonBanner>
    <div class="industry-information-container">
      <div class="talent-body-wrap home-mini-width hom-max-width">
        <TitleCard
          title="专利信息分析"
          :loading="loading"
          :isEmpty="isEmpty"
          :showMore="true"
          @moreClick="moreClick"
        >
          <div class="searchCard">
            <TableCard
              :tableList="dataList"
              @moreChange="patentToDetails"
            ></TableCard>
          </div>
        </TitleCard>
      </div>
    </div>
    <CodeModel v-if="isShowCode"
               @cancel="codeCancel"></CodeModel>
  </div>
</template>

<script>
import TableCard from '@/components/common/tableCard'
import { Mixin } from './pages/mixins'
import { getIndustryInfo } from '@/api/IpProject'
import { picList } from './configs/config'
import commonBanner from '@/components/common/banner'
import CodeModel from '../MPlatformPortal/components/codeModel.vue'

export default {
  data() {
    return {
      picList,
      isShowCode: false,
      loading: false,
      isEmpty: false,
      dataList: [],
      bgImg: require('@/assets/images/专利信息分析banner.png')
    }
  },
  mixins: [Mixin],
  components: {
    TableCard,
    commonBanner,
    CodeModel
  },
  mounted() {
    this.requestPatentList()
  },
  methods: {
    moreClick(){
      this.isShowCode = true
    },
    codeCancel() {
      this.isShowCode = false
    },
    // 请求专利信息
    async requestPatentList() {
      let id = process.env.VUE_APP_OFFICE_ID
      let params = {
        pageNum: 1,
        pageSize: 2,
        id: id,
      }
      let res = await getIndustryInfo(params)
      this.loading = false
      this.isEmpty = res.total === 0
      this.dataList = res.data.reduce((pre, item, index) => {
        item = {
          ...item,
          img: this.picList[index],
        }
        pre.push(item)
        return pre
      }, [])
    },
    patentToDetails(item) {
      this.$router.push({
        path: `/IndustryInformation/IndustryInformationList?id=${item.id}&name=${item.name}`,
      })
    },
  },
}
</script>
<style scoped>
.infos-wrap {
  display: inline-block;
}
</style>
